import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import RegimenBuilder from "@/pages/RegimenBuilder";
import FindClinic from "@/pages/FindClinic";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/skin-analysis" element={<RegimenBuilder />} />
          <Route path="/find-a-dermatologist" element={<FindClinic />} />
        </Route>
        <Route
          path="/admin"
          element={
            <div className="App bg-base min-h-screen">
              <Admin />
              <Toaster position="top-center" richColors />
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
